import type { JsonRecord } from "../Types/SocialListeningTypes";

const isJsonRecord = (value: unknown): value is JsonRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const asRecord = (value: unknown): JsonRecord | null => (isJsonRecord(value) ? value : null);

export const asArray = (value: unknown): unknown[] => (Array.isArray(value) ? value : []);

export const asStringArray = (value: unknown): string[] =>
  asArray(value).filter((item): item is string => typeof item === "string");

export const toNumber = (value: unknown, fallback = 0): number => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};
